import './styles/main.css';
import { loadIndexes } from './data/fetch';
import { isPaused, loadLastFactoryRun } from './data/experiment';
import { pauseNoticeHtml } from './ui/callouts';
import { initTheme, toggleTheme } from './theme';
import { formatDate } from './ui/util';

initTheme();

document.getElementById('theme-toggle')?.addEventListener('click', toggleTheme);

async function fillStats(): Promise<void> {
  const strip = document.getElementById('stats-strip');
  if (!strip) return;
  try {
    const { entries } = await loadIndexes();
    if (entries.length === 0) {
      strip.hidden = true;
      return;
    }
    const tools = entries.filter((e) => e.type === 'tool').length;
    const sites = entries.filter((e) => e.type === 'web').length;
    const apps = entries.filter((e) => e.type === 'app').length;
    const games = entries.filter((e) => e.type === 'game').length;
    const earliest = entries.reduce((min, e) => (e.date < min ? e.date : min), entries[0].date);
    const stat = (num: number | string, label: string) =>
      `<div class="figure"><span class="figure-num">${num}</span><span class="xp-label">${label}</span></div>`;
    strip.innerHTML = [
      stat(tools, 'browser tools'),
      stat(sites, 'data sites'),
      games > 0 ? stat(games, 'web games') : '',
      apps > 0 ? stat(apps, 'iOS apps') : '',
      stat(formatDate(earliest), 'building since'),
    ]
      .filter(Boolean)
      .join('');
  } catch {
    strip.hidden = true;
  }
}

void fillStats();

/** Says so when the factories have stopped for now, so the page doesn't read as abandoned. */
async function fillStatus(): Promise<void> {
  const slot = document.getElementById('experiment-status');
  if (!slot) return;
  const lastRun = await loadLastFactoryRun();
  slot.innerHTML = lastRun && isPaused(lastRun, Date.now()) ? pauseNoticeHtml(lastRun) : '';
}

void fillStatus();
